/* eslint-disable max-len */
/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ViewContainerRef, TemplateRef, ViewChild, Input } from '@angular/core';
import { ItineraryService } from '../itinerary.service';
import { FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { CustomValidator } from '../customValidators';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { RestService } from '../rest.service';
import { UserService } from '../../pages/com.usblick.common/auth/user.service';
import { SelectAgencyModalComponent } from '../select-agency-modal/select-agency-modal.component';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { setting } from '../../../../setting';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmationModalComponent } from '../modals/confirmation-modal/confirmation-modal.component';
import { ClientListModalComponent } from '../modals/client-list-modal/client-list-modal.component';
import { MaterialModalAlertComponent } from '../material-modal-alert/material-modal-alert.component';
moment.locale('es');
@Component({
  selector: 'usb-itinerary-owner',
  templateUrl: './itinerary-owner.component.html',
  styleUrls: ['./itinerary-owner.component.scss']
})
export class ItineraryOwnerComponent implements OnInit {
  @ViewChild('itineraryName')
  itineraryName!: HTMLInputElement;
  @ViewChild('name')
  nameClient!: HTMLInputElement;
  @ViewChild('email')
  emailClient!: HTMLInputElement;
  @ViewChild('codephone')
  codePhone!: HTMLInputElement;
  @ViewChild('phone')
  phoneClient!: HTMLInputElement;
  @Input() getClientsSettingAppBooking: any;
  @Input() currencyAgency: any;
  @Input()
  currencies!: any[];
  modalRef!: BsModalRef;
  loaded = false;
  chargeClient = false;
  saved = false;
  itineraryData: any;
  client: any;
  clientEmailTake = false;
  clientLoaded = false;
  draftLoaded = false;
  firstItinerary = true;
  _cookieClient: any = undefined;
  agencyID!: number;
  agencyEmail!: string;

  clientListAux: any;
  clientList: any;
  loading = true;
  p = 1;
  public sectionHeader: any;
  public clientExists = false;
  public clientCreated = false;
  public clientConectError = false;
  public reload = true;
  public countriesData: any[] = [];
  selectedPhoneCode: any;
  currencyItinerary: any;
  isPhoneValidating = false;

  bsModalRef?: BsModalRef;

  itineraryItems = false;

  // Datos del cliente elegido en el modal, para detectar si se editan antes de guardar
  private selectedClientSnapshot: { name: string; email: string; phoneCode: string; phone: string } | null = null;

  filterClient = {
    email: '',
    first_name: '',
    last_name:'',
  };

  currentPage = 1;
  lastPage!: number;
  booleanSelectDisable = false;
  filteredCountries = [];

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  private clientsAllSubscription!: Subscription;
  private verifyExistSubscription!: Subscription;
  private activeUserSubscription!: Subscription;
  private moduleToProfileSubscription!: Subscription;

  _formGroupItinerary!: FormGroup;

  //_formGroupItinerary: FormGroup;
  clientPut = false;

  config = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  itineraryArrivalDate: any;
  itineraryDepartureDate: any;

  itinerary$!: Observable<any[]>;

  href!: string;



  public moduleProfile: any[] = [];
  phoneCodeSelected = '';
  isHoveredCancelDate!: boolean;
  phoneSelectedCountryCode!: string;

  constructor(
    private itineraryService: ItineraryService,
    private formBuilder: FormBuilder,
    public vcr: ViewContainerRef,
    private modalService: BsModalService,
    private _router: Router,
    private _cookieService: CookieService,
    private restService: RestService,
    public userService: UserService,
    public dialog: MatDialog,
  ) {

    this.chargeClient = false;
  }


  ngAfterViewInit(): void {

    this._router.events
    .filter(event => event instanceof NavigationEnd)
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(() => {
      this.href =this._router.routerState.snapshot.url;
    });

  }


  ngOnInit() {
    this.chargeClient = false;

    this._formGroupItinerary = this.formBuilder.group({
      name: new FormControl(null, [Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]),
      phone_code_selected: new FormControl(null),
      phone_code: new FormControl(null, Validators.required),
      phone: new FormControl(null, [Validators.required, Validators.pattern(/^[0-9]{6,}$/)]),
      email: new FormControl(null, [Validators.required, CustomValidator.customEmailValidator]),
      title: new FormControl(null, Validators.required),
      client_id: new FormControl(null),
      status:new FormControl( null)
    });

    this.sectionHeader = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.section_header);
    this.getAgencyEmail();
    this.agencyId();

    let observableUser = false;

   this.activeUserSubscription = this.userService.activeUserSubject.asObservable().subscribe(
      (response: any) => {
        if(response){
          observableUser = true;
          if(response) {
            localStorage.setItem('selectedAgency', JSON.stringify(response));
            this.itineraryService.consultActiveItinerary(this.userService._agentID, false, this.itineraryData?.id, 'itinerary-owner');
            this._formGroupItinerary = this._initFormItinerary();
            this._initComponentWithService();
            this.itineraryItemsGoFile();
          }
        }
      }
    );

    this.itinerary$ = this.itineraryService.getItinerary$();
    this.itinerary$.subscribe((data: any) => {
      this.itineraryService.validateItineraryByStatus(this.userService.itineraryActive[0]);
      this.itineraryService.itinerary = this.userService.itineraryActive[0];
      this.itineraryItemsGoFile();
      this._initComponentWithService();
      this.itineraryArrivalDate = this.itineraryService.itineraryArrivalDate;
      this.itineraryDepartureDate = this.itineraryService.itineraryDepartureDate;

    });

      if (!observableUser) {
        this._initComponentWithService();
      }

    this.chargeClient = false;

    this.itineraryService.currencySuccessEmit.subscribe({
      next: (res: any) => {
        if(res) {
          this.currencyItinerary = res;
        }
      }
    });



  }

  itineraryItemsGoFile(): void {
      this.itineraryItems = this.itineraryService.itinerary?.items &&
                            Array.isArray(this.itineraryService.itinerary?.items) &&
                            this.itineraryService.itinerary?.items.length > 0 ?
                            true :
                            false;
  }

  onPhoneFocus() {
    this._formGroupItinerary.get('phone')?.setErrors({ invalidPhone: true });
  }

  async onPhoneBlur(): Promise<boolean> {
    return true;
}

  updateMySelectionNationality(event: any) {
    if(event) {
      this._formGroupItinerary.get('phone_code')?.setValue(event);
      this._formGroupItinerary.get('phone_code')?.setErrors(null);
      this._formGroupItinerary.get('phone_code')?.updateValueAndValidity();
      const phoneSelected = this.countriesData.find(c => c.phone_code === event);
      this.phoneSelectedCountryCode = phoneSelected?.country_code;
      this.phoneCodeSelected = `${phoneSelected.country_name} (+${phoneSelected.phone_code})`;
    }
  }

  resetPhoneCode(): void {
    this._formGroupItinerary.get('phone_code')?.setValue(null);
    this._formGroupItinerary.get('phone_code')?.setErrors({error: true});
    this.phoneCodeSelected = '';
  }

  isGuardarButtonEnabled(): boolean {
    const nameControl = this._formGroupItinerary.get('name');
    const emailControl = this._formGroupItinerary.get('email');
    const phoneControl = this._formGroupItinerary.get('phone');
    const phoneCodeControl = this._formGroupItinerary.get('phone_code');
    const titleControl = this._formGroupItinerary.get('title');

    return nameControl?.valid &&
           phoneCodeControl?.valid &&
           emailControl?.valid &&
           phoneControl?.valid &&
           titleControl?.valid || false;
  }


  openAgencyModal(data) {
    const dialogRef = this.dialog.open(SelectAgencyModalComponent, {
      data,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this._initComponentWithService();
    });
  }


  verifyCookie(): boolean {

    this._cookieClient = (this._cookieService.get('clientActive') != undefined) ? this._cookieService.get('clientActive') : undefined;

    if (this._cookieClient !== undefined) {
      const data = this._cookieClient.split('||');

      this._formGroupItinerary = this.formBuilder.group({
        name: [{ value: data[2].length <= 1 ? '' : data[2].trim(), /* disabled: true */ }, [Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
        phone_code: [{ vale: data[6].trim(), /* disabled: true */}, Validators.required],
        phone: [{ value: data[4].trim(), /* disabled: true */ }, [Validators.required, Validators.pattern(/^[0-9]{10,}$/)]],
        email: [{ value: data[3].trim(), /* disabled: true */ }, Validators.required],
        title: [{ value: data[1].trim(), /* disabled: true */ }, Validators.required],
        client_id: data[0],
        status: (data[5] !== undefined) ? data[5] : ''
      });



      //esto esta bien si existe data pasar a true de inmediato
      this.loaded = true;
      // confuso
      this.saved = true;

      //console.log("coloca data del coockie");

      return true;
    }
    return false;
  }

  _initComponent() {


    this.itinerary$ = this.itineraryService.getItinerary$();
    this.itinerary$.subscribe((data: any) => {
      if (data.length > 1) { //aqui sabemos si efectivamente hay un cliente
        this.itineraryArrivalDate = this.itineraryService.itineraryArrivalDate;
        this.itineraryDepartureDate = this.itineraryService.itineraryDepartureDate;


        this._cookieService.put('clientActive', data[0].client_id + '||' + data[0].title + '||' + ((data[1].first_name == null || data[1].first_name == 'false') ? '' : data[1].first_name) + ' ' + (data[1].last_name == null ? '' : data[1].last_name) + '||' + (data[1].email == null ? '' : data[1].email) + '||' + (data[1].phone == null ? '' : data[1].phone) + '||' + (data[1].state == null ? '' : data[1].state));

        let names;
        if (data[1].first_name !== '<first_name>' && data[1].first_name !== 'false') {
          names = data[1].first_name + ' ' + ((data[1].last_name == null) ? '' : data[1].last_name);
        } else {
          names = '';
        }

        if (this._cookieClient === undefined) {
          this._formGroupItinerary = this.formBuilder.group({
            name: [{ value: (names && names.length <= 1) ? '' : names, /* disabled: true */ }, [Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
            phone: [{ value: data[1].phone, /* disabled: true */ }, [Validators.required, Validators.pattern(/^[0-9]{6,}$/)]],
            email: [{ value: data[1].email, /* disabled: true */ }, Validators.required],
            title: [{ value: data[0].title, /* disabled: true */ }, Validators.required],
            client_id: data[1].id,
            status: data[1].status
          });
        }
        this.itineraryData = data[0];
        this.loaded = true;
        this.saved = true;


      } else {

        this._cookieService.put('clientActive', undefined);
        this._cookieClient = undefined;
        this.saved = false;
        this.loaded = true;
        this.draftLoaded = false;

        this._formGroupItinerary = this.formBuilder.group({
          name: [null,[Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
          phone_code_selected: [null],
          phone_code: [null, Validators.required],
          phone: [null, [Validators.required, Validators.pattern(/^[0-9]{6,}$/)]],
          email: [null, Validators.required],
          title: [null, Validators.required],
          client_id: null
        });
      }
      //})

    });
  }

  _initComponentWithService() {

    this.userService.calculateDates();
    if (this.userService.itineraryActive) {

      if (this.userService.itineraryActive.length > 1) { //aqui sabemos si efectivamente hay un cliente

        this.itineraryArrivalDate = this.itineraryService.itineraryArrivalDate;
        this.itineraryDepartureDate = this.itineraryService.itineraryDepartureDate;
        this._cookieService.put('clientActive', this.userService.itineraryActive[0].client_id + '||' + this.userService.itineraryActive[0].title + '||' + ((this.userService.itineraryActive[1].first_name == null || this.userService.itineraryActive[1].first_name == 'false') ? '' : this.userService.itineraryActive[1].first_name) + ' ' + (this.userService.itineraryActive[1].last_name == null ? '' : this.userService.itineraryActive[1].last_name) + '||' + (this.userService.itineraryActive[1].email == null ? '' : this.userService.itineraryActive[1].email) + '||' + (this.userService.itineraryActive[1].phone == null ? '' : this.userService.itineraryActive[1].phone) + '||' + (this.userService.itineraryActive[1].state == null ? '' : this.userService.itineraryActive[1].state)) + '||' + (this.userService.itineraryActive[1].phone_code);


        let names;
        if (this.userService.itineraryActive[1].first_name !== '<first_name>' && this.userService.itineraryActive[1].first_name !== 'false') {
          names = this.userService.itineraryActive[1].first_name + ' ' + ((this.userService.itineraryActive[1].last_name == null) ? '' : this.userService.itineraryActive[1].last_name);
        } else {
          names = '';
        }

        this._formGroupItinerary = this.formBuilder.group({
          name: [(names && names.length <= 1) ? '' : names, [Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
          phone_code: [this.userService.itineraryActive[1].phone_code, Validators.required],
          phone: [this.userService.itineraryActive[1].phone, [Validators.required, Validators.pattern(/^[0-9]{6,}$/)]],
          email: [ this.userService.itineraryActive[1].email, Validators.required],
          title: [this.userService.itineraryActive[0].title, Validators.required],
          client_id: this.userService.itineraryActive[1].id,
          status: this.userService.itineraryActive[0].status
        });

        this.itineraryData = this.userService.itineraryActive[0];
        this.loaded = true;
        this.saved = true;

      } else {

        this._cookieService.put('clientActive', undefined);
        this._cookieClient = undefined;
        this.saved = false;
        this.loaded = true;
        this.draftLoaded = false;

        this._formGroupItinerary = this.formBuilder.group({
          name: [null, [Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
          phone_code_selected: [null],
          phone_code: [null, Validators.required],
          phone: [null, [Validators.required, Validators.pattern(/^[0-9]{6,}$/)]],
          email: [null, [Validators.required,  CustomValidator.customEmailValidator]],
          title: [null, Validators.required],
          client_id: null
        });
      }
    }

    setTimeout(() => {
    }, 3000);
  }

  _initFormItinerary(): FormGroup {
    if (this._cookieClient !== undefined) {
      const data = this._cookieClient.split('||');
      const _itinerary: FormGroup = this.formBuilder.group({
        name: [{ value: data[2].length <= 1 ? '' : data[2].trim(), /* disabled: true */ }/*, CustomValidator.fullNameValidator*/],
        phone: [{ value: data[4], /* disabled: true */ }, [Validators.required, Validators.pattern(/^[0-9]{6,}$/)]],
        phone_code: [{value: data[6], /* disabled: true */}, Validators.required],
        email: [{ value: data[3], /* disabled: true */ }, Validators.required,  /* CustomValidator.customEmailValidator */],
        title: [{ value: data[1], /* disabled: true */ }, Validators.required],
        client_id: data[0],
        status: (data[5] !== 'undefined') ? data[5] : ''
      });
      return _itinerary;
    } else {
      const _itinerary: FormGroup = this.formBuilder.group({
        name: [null/*, CustomValidator.fullNameValidator*/],
        phone_code: [null, Validators.required],
        phone_code_selected: [null],
        phone: [null, [Validators.required, Validators.pattern(/^[0-9]{6,}$/)]],
        email: [null, [Validators.required, Validators.email]],
        title: [null, [Validators.required, /* CustomValidator.notOnlySpaceBlank */]],
        client_id: null,
        status: null
      });
      return _itinerary;
    }
  }

  resetSaveFormFields(flag: boolean) {
    if (flag) {
      this._formGroupItinerary = this.formBuilder.group({
        name: [null, [Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
        phone_code: [null, Validators.required],
        phone_code_selected: [null],
        phone: [null,[Validators.required, Validators.pattern(/^[0-9]{6,}$/)]],
        email: [null, Validators.required],
        title: [null, [Validators.required, /* CustomValidator.notOnlySpaceBlank */]],
        client_id: null,
        status: null
      });


      this.displayCountry(null);


      this.clientLoaded = false;
    }
  }

  async saveFirstItinerary() {
    if(!this._formGroupItinerary.valid) {
return;
}

    let newItinerary = true;
    this.loaded = false;
    this.saved = false;
    this.chargeClient = true;

    if (!this.clientLoaded) {
      let fullName;

      if (this._formGroupItinerary.value['name'] !== null && this._formGroupItinerary.value['name'] !== undefined &&
        this._formGroupItinerary.value['name'].trim() !== '') {
        fullName = this._formGroupItinerary.value['name'].trim().split(' ', 2);
      } else {
        fullName = ['false', ''];
      }

      const data: any = {
        first_name: fullName[0],
        last_name: (fullName[1] === undefined || fullName[1] === null) ? '' : fullName[1],
        email: this._formGroupItinerary.value['email'] ? this._formGroupItinerary.value['email'] : '',
        phone_code: this.phoneCodeSelected ? this.phoneCodeSelected : '',
        phone: String(this._formGroupItinerary.value['phone'] ? this._formGroupItinerary.value['phone'] : ''),
        itineraryOwner: true,

      };

      if (this.draftLoaded === true) {
        newItinerary = false;
      }
      this.itineraryService.postDataClient(data)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(
        (response: any) => {
          if (response.success) {

            const itinerary: any = {
              client_id: response.id,
              title: this._formGroupItinerary.value['title'],
              clientId: this.getClientsSettingAppBooking.id,
            };

            if (newItinerary) {
              this.itineraryService.postDataItinerary(itinerary, 'Saved');
            } else {
              this.itineraryData.status = 'Saved';
              this.itineraryData.client_id = itinerary.client_id;
              this.itineraryData.title = itinerary.title;
              this.itineraryData.clientId = this.getClientsSettingAppBooking.id;
              this.itineraryData.agent_id = this.userService._agentID;
              this.itineraryData.currency = this.userService.itineraryActive ? this.userService.itineraryActive[0].currency : null;
              this.itineraryService.updateActiveItinerary(this.itineraryData, true);
            }

            const agent = JSON.parse(localStorage.getItem('selectedAgency'));

            const client = {
              client_id: response.id,
              agency_id: this.userService._agencyID ? this.userService._agencyID : agent.agency_id,
              agent_create: this.userService._agentID ? this.userService._agentID : agent.agent_id,
            };
            this.itineraryService.addClientToAgency(client)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
              next: (response: any) => {
                  const success = response.success;
                  if(!success) {
                    this.clientExists = true;

                    setTimeout(() => {
                      this.clientExists = false;
                    }, 5000);
                  } else {
                    this.clientCreated = true;

                    setTimeout(() => {
                      this.clientCreated = false;
                    }, 5000);
                  }
              },
              error: (error: Error) => {
                this.clientConectError = true;

                setTimeout(() => {
                  this.clientConectError = false;
                }, 5000);
              }
            });

            this.chargeClient = false;
            this.loaded = true;
            this.saved = true;
          }

        }, Error => {
          const errorParsed = JSON.parse(Error);

          this._cookieService.put('clientActive', undefined);

          if (!errorParsed.success && errorParsed.message === 'Client Exist') {

            this.restService.doGet('app', 'clientsAll?adult=true')
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
              (data: any) => {
                this.clientListAux = data.data;
                this.clientList = this.clientListAux;

                const email =  this._formGroupItinerary.value['email'];

                const clientFound = this.clientList.find( element => element.email == email);

                this.selectClient(clientFound);

                const itinerary: any = {
                  client_id: this.client.id,
                  title: this._formGroupItinerary.value['title'],
                  clientId:  this.getClientsSettingAppBooking.id
                };
                if (this.draftLoaded === true) {
                  newItinerary = false;
                }
                if (newItinerary) {
                  this.itineraryService.postDataItinerary(itinerary, 'Saved');
                } else {
                  this.itineraryData.status = 'Saved';
                  this.itineraryData.client_id = itinerary.client_id;
                  this.itineraryData.title = itinerary.title;
                  this.itineraryData.clientId = this.getClientsSettingAppBooking.id;
                  this.itineraryService.updateActiveItinerary(this.itineraryData, true);
                }
              },

              error => {
                console.log(error);
              }
            );

          } else if (typeof (Error) === 'string') {
            if (Error !== undefined) {
              console.warn('Client Error');
              const errores = JSON.parse(Error);
              if (errores.errors.email !== undefined && errores.errors.email[0]) {
                const errorish = errores.errors.email[0];
                if (errorish === 'The email has already been taken.') {
                  this.clientEmailTake = true;
                  this._formGroupItinerary.get('email').setErrors({ emailTaken: true });
                }
              }
            }
          }

        }

      );

      this.clientLoaded = false;


    } else {
      const data: Object = {
        client_id: this._formGroupItinerary.value['client_id'],
        title: this._formGroupItinerary.value['title'],
        clientId:this.getClientsSettingAppBooking.id,
      };
      const itinerary: any = {
        client_id: this.client.id,
        title: this._formGroupItinerary.value['title'],
        clientId:this.getClientsSettingAppBooking.id,
      };
      if (this.draftLoaded === true) {
        newItinerary = false;
      }
      if (newItinerary) {
        this.itineraryService.postDataItinerary(itinerary, 'Saved');
      } else {
        this.itineraryData.status = 'Saved';
        this.itineraryData.client_id = itinerary.client_id;
        this.itineraryData.title = itinerary.title;
        this.itineraryData.clientId = this.getClientsSettingAppBooking.id;
        this.itineraryService.updateActiveItinerary(this.itineraryData, true);
      }
    }

  }

/**
 * Verifica la existencia de un cliente y guarda un nuevo itinerario.
 *
 * Este método realiza una verificación en el backend para determinar si un cliente ya existe en la base de datos
 * a partir del email proporcionado. Si el cliente no existe, guarda un nuevo itinerario llamando a `saveFirstItinerary()`.
 * En caso de que el cliente ya exista, se abre un modal para confirmar si se desea guardar como nuevo cliente.
 * Si se confirma, se procede a guardar el itinerario.
 *
 * @payload -> objeto que contiene el email a verificar.
 * @verifyExistSubscription -> suscripción al servicio de verificación.
 * @res.exist -> respuesta del backend que indica si el cliente existe o no.
 * @bsModalRef -> referencia al modal de confirmación para decidir si guardar como nuevo cliente.
 *
 * @restService.doPost('app', 'checkClient', payload) -> hace una petición POST para verificar la existencia del cliente.
 */


verifyExist(): void {
  if(!this.isGuardarButtonEnabled()) {
return;
}

  const payload = {
    email: this._formGroupItinerary.get('email').value
  };

  this.verifyExistSubscription = this.restService.doPost('app', 'checkClient', payload)
    .subscribe({
      next: (res: any) => {
        if (res) {
          if (res.exist === true) {
            this.saveFirstItinerary(); // Guarda un nuevo itinerario si el cliente no existe.
          } else {
            const initialState: ModalOptions = {
              initialState: {
                message: 'Se guardará como nuevo cliente. ¿Está seguro?' // Mensaje en el modal de confirmación.
              }
            };
            this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);

            const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
              if (result) {
                this.saveFirstItinerary(); // Guarda el itinerario si se confirma la acción en el modal.
              }
              confirmSubscription.unsubscribe(); // Finaliza la suscripción al confirmar la acción.
            });
          }
        }
      }
    });
}


  newItinerary() {
    this.reload = false;

    const agent = localStorage.getItem('selectedAgency');
   /// localStorage.clear();
    localStorage.setItem('selectedAgency', agent);

    this._cookieService.put('clientActive', undefined);
    this._cookieService.remove('clientActive');
    this._cookieClient = undefined;

    // console.log('itinerarydata ->', this.itineraryData);

    if (this.itineraryData != undefined) {
      this.itineraryData.active = false;
      this.itineraryData.status = 'Saved';
    } else {
      this.itineraryData = this.userService.itineraryActive[0];
    }


    this.resetSaveFormFields(true);
    this.draftLoaded = false;
    this.loaded = true;
    this.itineraryData.currency = this.userService.itineraryActive[0] ? this.userService.itineraryActive[0].currency : null;
    this.itineraryService.updateActiveItinerary(this.itineraryData, false);


    setTimeout(() => {
      this.reload = true;
      this.saved = false;
      // Comprobar la ruta actual
      const currentRoute = this._router.url;
      if (currentRoute !== '/home') {
        window.location.href = `${setting.appBookingUrl}`;
      }
    }, 1000);

  }

  openNewItinerary(){
    this.restService.setPassengersData(null);

    const initialState: ModalOptions = {
      initialState: {
        icon: 'assets/icons/POPUP_GUARDAR.svg',
        title: 'Guardar',
        subtitle: 'Itinerario',
        message: 'Guardará su itinerario actual <br /> y comenzará un nuevo borrador de file. <br /> ¿Está seguro?'
      }
    };

    const modalOptions = Object.assign({}, initialState, this.config);
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, modalOptions);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if(result) {
        this.userService.itineraryActive = [];
        this.newItinerary();
        // Mostrar el formulario de nuevo file (header líneas 10-236)
        this.saved = false;
        this.loaded = true;
        // Recargar categorías para limpiar formularios
        this.restService.reloadSearchCategories$.next(true);
      } else {

      }
      confirmSubscription.unsubscribe();
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }

openModalExtraLarge() {
    const initialState = {
      initialState: {
        clientEmail: this._formGroupItinerary.get('email')?.value ?? '',
      },
      class: 'modal-lg modal-edit-search',
    };
    this.modalRef = this.modalService.show(ClientListModalComponent, initialState);

    this.modalRef.content.clientSelected.subscribe((client: any) => {
      this.selectClient(client);
    });
  }

  closeModal(): void {
    this.modalRef.hide();
  }

  loadClients(page: number) {
    const goPage = (page>1) ? '&page='+page : '';
    const url = `clientsAll?agency_id=${this.userService._agencyID}${goPage}&paginate=5&adult=true`;
  this.clientsAllSubscription = this.restService.doGet('app', url)
  .pipe(takeUntil(this._unsubscribeAll))
  .subscribe(
      (data: any) => {
        this.clientListAux = data.data;
        this.clientList = this.clientListAux.data;
        this.lastPage = this.clientListAux.last_page;
        this.currentPage = this.clientListAux.current_page;
        this.loading = false;
      },
      error => {
        console.log('error get clients');
      }
    );
  }

  showMoreResult(more){
    if(more == '+'){
      this.currentPage = this.currentPage+1;
      this.loadClients(this.currentPage);
    }else{
      this.currentPage = this.currentPage-1;
      this.loadClients(this.currentPage-1);
    }
  }

  resetFilterClient(event){
    this.loadClients(this.currentPage);
  }

  goPage(event){
    this.loadClients(event);
  }

  selectClient(client: any) {

    this.client = client;
    this._formGroupItinerary = this.formBuilder.group({
      name: [null,[Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
      phone_code_selected: [null],
      phone_code: [null, [Validators.required]],
      phone: [null, [Validators.required, Validators.pattern(/^[0-9]{6,}$/)]],
      email: [null, [Validators.required,CustomValidator.customEmailValidator]],
      title: [ this._formGroupItinerary.value['title'], Validators.required],
      client_id: null
    });

    // Usar los datos resueltos del modal o resolverlos aquí
    const phoneCodeToUse = client.phone_code_number || client.phone_code;
    this.getCountries(true, client.phone_code);
    const clientName = client.first_name + (client.last_name ? (' ' + client.last_name)  : '' );
    this._formGroupItinerary.patchValue({
      name: clientName,
      email: client.email,
      phone_code_selected: client.phone_code_resolved || client.phone_code,
      phone_code: phoneCodeToUse,
      phone: client.phone,
      client_id: client.id
    });

    this.selectedClientSnapshot = {
      name: this.normalizeName(clientName),
      email: this.normalizeEmail(client.email),
      phoneCode: this.onlyDigits(client.phone_code),
      phone: this.onlyDigits(client.phone),
    };

    this.clientLoaded = true;
  }

  /**
   * Guardar con un cliente elegido del listado.
   * Si se modificó nombre, email, código de país o teléfono, pide confirmación:
   * con "Sí" se actualiza el cliente y se guarda el file; con "No" se vuelve al form.
   */
  saveSelectedClient(): void {
    if (!this.isGuardarButtonEnabled()) {
      return;
    }

    const modifiedFields = this.getModifiedClientFields();
    if (modifiedFields.length === 0) {
      this.saveFirstItinerary();
      return;
    }

    const initialState: ModalOptions = {
      initialState: {
        title: 'Datos modificados',
        message: `Se modificaron datos del cliente seleccionado: <b>${modifiedFields.join(', ')}</b>.<br />` +
                 'Si continúa, el cliente se actualizará con estos datos. ¿Desea continuar?',
        confirmText: 'Sí',
        cancelText: 'No',
      }
    };

    const modalOptions = Object.assign({}, initialState, this.config);
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, modalOptions);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if (result) {
        this.updateSelectedClientAndSave();
      }
      confirmSubscription.unsubscribe();
    });
  }

  /**
   * Campos del cliente elegido que difieren de los originales (etiquetas para el aviso).
   */
  private getModifiedClientFields(): string[] {
    if (!this.selectedClientSnapshot) {
      return [];
    }

    const value = this._formGroupItinerary.value;
    const original = this.selectedClientSnapshot;
    const modified: string[] = [];

    if (this.normalizeName(value.name) !== original.name) {
      modified.push('Nombre');
    }
    if (this.normalizeEmail(value.email) !== original.email) {
      modified.push('Email');
    }
    if (this.onlyDigits(value.phone_code) !== original.phoneCode) {
      modified.push('Código de país');
    }
    if (this.onlyDigits(value.phone) !== original.phone) {
      modified.push('Teléfono');
    }

    return modified;
  }

  /**
   * Actualiza el cliente elegido con los datos del form y, si sale bien, guarda el file.
   * Se envía el registro completo del cliente para no perder los demás campos.
   */
  private updateSelectedClientAndSave(): void {
    const value = this._formGroupItinerary.value;
    const [firstName, ...lastNameParts] = (value.name || '').trim().split(/\s+/);

    const { phone_code_resolved, phone_code_number, ...clientRecord } = this.client || {};
    const payload = {
      ...clientRecord,
      id: this.client.id,
      first_name: firstName,
      last_name: lastNameParts.join(' '),
      email: (value.email || '').trim(),
      phone_code: this.phoneCodeSelected || this.client.phone_code,
      phone: String(value.phone || ''),
    };

    this.chargeClient = true;
    this.itineraryService.updateClient(payload)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (response: any) => {
          this.chargeClient = false;
          if (response?.success === false) {
            this.showClientUpdateError(response);
            return;
          }

          // El cliente quedó actualizado: pasa a ser el nuevo "original"
          this.client = { ...this.client, ...payload };
          this.selectedClientSnapshot = {
            name: this.normalizeName(value.name),
            email: this.normalizeEmail(payload.email),
            phoneCode: this.onlyDigits(value.phone_code),
            phone: this.onlyDigits(payload.phone),
          };
          this.saveFirstItinerary();
        },
        error: (error: any) => {
          this.chargeClient = false;
          this.showClientUpdateError(error);
        }
      });
  }

  private showClientUpdateError(error: any): void {
    let parsed: any = error;
    if (typeof error === 'string') {
      try {
        parsed = JSON.parse(error);
      } catch {
        parsed = null;
      }
    }

    if (parsed?.errors?.email) {
      this.clientEmailTake = true;
      this._formGroupItinerary.get('email')?.setErrors({ emailTaken: true });
    }

    this.dialog.open(MaterialModalAlertComponent, {
      width: '400px',
      data: parsed?.errors?.email
        ? 'El email ingresado ya pertenece a otro cliente. Revise los datos.'
        : 'No se pudo actualizar el cliente. Revise los datos e intente nuevamente.',
      disableClose: true
    });
  }

  private normalizeName(value: any): string {
    return String(value ?? '').trim().replace(/\s+/g, ' ').toLowerCase();
  }

  private normalizeEmail(value: any): string {
    return String(value ?? '').trim().toLowerCase();
  }

  // Ej: 'Argentina (+54)', '+54', 54 -> '54'
  private onlyDigits(value: any): string {
    const text = String(value ?? '');
    const insideParens = text.match(/\(\+?(\d+)\)/);
    return insideParens ? insideParens[1] : text.replace(/\D/g, '');
  }


  filterClients() {
    const first_name  = this.filterClient.first_name;
    const email  = this.filterClient.email;
    const last_name = this.filterClient.last_name;
    //llame al metodo para poder pasar el name y el email
    this.filterByclients(this.currentPage, first_name, email, last_name);


  }

  resetSearch() {
    this.clientList = this.clientListAux;
    this.filterClient.email = null;
    this.filterClient.first_name = null;
    this.filterClient.last_name = null;
    this.loadClients(this.currentPage);
  }

  setDateHead(date: string) {
    if (date) {
      const dateSplit = date.split('-');
      return '' + dateSplit[2] + '-' + moment().month(parseInt(dateSplit[1]) - 1).format('MMM-Y');
    }
  }

  setArrivalDate(): string{
    if (this.itineraryArrivalDate) {
      const dateSplit = this.itineraryArrivalDate.split('-');
      return '' + dateSplit[2] + '-' + moment().month(parseInt(dateSplit[1]) - 1).format('MMM-Y');
    }else{
      return '';
    }
  }

  setDepartureDate(): string{
    if(this.itineraryDepartureDate){
      const dateSplit = this.itineraryDepartureDate.split('-');
      return '' + dateSplit[2] + '-' + moment().month(parseInt(dateSplit[1]) - 1).format('MMM-Y');
    }else{
      return '';
    }
  }

  active() {

    if (this.userService.itineraryActive[0].arrivalDate) {
      // this._router.navigate(['/multi-destination']);
      const navigationExtras: NavigationExtras = {
        queryParams: {
          id: this.userService.itineraryActive[0].id,
          //'stat': this.status,
          screen: 'detail'
        }
      };
      this._router.navigate(['/itinerary-detail'], navigationExtras);

    }

  }

  get name() {
 return this._formGroupItinerary.get('name');
}
  get email() {
 return this._formGroupItinerary.get('email');
}
  get phone_code() {
 return this._formGroupItinerary.get('phone_code');
}
  get phone() {
 return this._formGroupItinerary.get('phone');
}
  get title() {
 return this._formGroupItinerary.get('title');
}

  agencyId(): number {
    this.agencyID = this.userService._agencyID;
   // console.log (this.agencyID)
    return this.agencyID ? this.agencyID : null;
  }

  getAgencyEmail(): string {
    this.agencyEmail = this.userService._email;
//console.log (this.agencyEmail)
    return this.agencyEmail ? this.agencyEmail : null;
  }

  getCountries(selectClientModal?: boolean, phone_code?: any) {

    this.itineraryService._restService.doGet('app', 'utilities/countries')
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe({
      next: (res: any) => {
        this.countriesData = res.Countrys;
        this.filteredCountries = this.countriesData;

        if(selectClientModal === true) {
          // Inicializa el valor del input de país
          this.filterCountries('');
          // phone_code = phone_code.splice()
            // Extracción segura del código
            const cleanPhoneCode = phone_code.match(/\((\+\d+)\)/)
              ? phone_code.match(/\((\+\d+)\)/)[1].replace('+', '')
              : phone_code;

            // Buscar el país
            const country = this.countriesData.find(c => c.phone_code === cleanPhoneCode);

          if (country) {
// console.log(country)
            this.updateMySelectionNationality(country.phone_code);
            // this.phoneCodeSelected = phone_code;
            this._formGroupItinerary.patchValue({
              phone_code: Number(country.phone_code)
            });
          }
        }
      }
    });


  }

  phoneCode(code: any) {
    code = Number(code);
    this._formGroupItinerary.controls['phone_code'].setValue(code);
  }

  filterCountries(searchText: string) {
    if (searchText) {
      this.filteredCountries = this.countriesData.filter(country =>
        country.country_name.toLowerCase().includes(searchText.toLowerCase())
      );
    } else {
      this.filteredCountries = this.countriesData;
    }
  }

  displayCountry = (country: any) => {
    if(country) {
      if (!this.filteredCountries) {
        console.error('filteredCountries is not defined');
        return '';
      }
      let countryData = this.filteredCountries.find(c => Number(c.phone_code) === Number(country));
      if(country === null) {
        countryData = null;
      }
      return countryData ? `${countryData.country_name} (+${countryData.phone_code})` : '';
    }
  };

  phoneCodeClient(phoneCode: string): string {
    if(phoneCode) {
      const match = phoneCode.match(/\(\+\d+\)/);
      if (match) {
        return match[0];
       } else {
        return `(+${phoneCode})`;
        }
      }
      return ''; // Devuelve una cadena vacía si no se encuentra el patrón
    }

    filterByclients(page: number, name?: string, emailValue?: string, last_nameValue?: string) {
      const goPage = (page>1) ? 'page='+page : '';

      const first_name = name? '&first_name='+name : '';
      const last_name = last_nameValue? '&last_name='+last_nameValue : '';
      const email = emailValue? '&email='+emailValue : '';

      this.clientsAllSubscription = this.restService.doGet('app', 'clients?&agency_id='+this.userService._agencyID+goPage+'&paginate=10'+first_name+last_name+email+ '&adult=true')
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(
          (data: any) => {
            this.clientListAux = data.data;
            this.clientList = this.clientListAux.data;
            this.lastPage = this.clientListAux.last_page;
            this.currentPage = this.clientListAux.current_page;
            this.loading = false;
          },
          error => {
            console.log('error get clients');
          }
        );
      }

     /**
      * Bloquea la entrada de caracteres no deseados (`e`, `E`, `+`, `-`) en campos numéricos.
      * @param event El evento de teclado.
      */
blockInvalidKeys(event: KeyboardEvent, input?: string) {
    const key = event.key;

    switch (input) {
        case 'name':
           const inputElementName = event.target as HTMLInputElement;
            const currentValueName = inputElementName.value || '';
            const selectionStartName = inputElementName.selectionStart ?? 0;

            // Permitir teclas de control
            if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) {
                return;
            }

            // Validar espacio
            if (key === ' ') {
                if (selectionStartName === 0) {
                    event.preventDefault();
                    return;
                }
                if (selectionStartName > 0 &&
                    currentValueName.charAt(selectionStartName - 1) === ' ') {
                    event.preventDefault();
                    return;
                }
                return;
            }

            // Solo letras (con acentos y ñ)
            if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1]$/.test(key)) {
                event.preventDefault();
            }
            break;

        case 'number':
            if (['e', 'E', '+', '-', ',', '.'].includes(key)) {
                event.preventDefault();
              }
            break;
    }
  }

  /**
   * Limpia el valor del input de teléfono dejando solo dígitos.
   * Se ejecuta en (input) para sanitizar lo que se tipea y también
   * lo que se pega desde el portapapeles (sin caracteres no numéricos).
   * @param event El evento de input.
   */
  sanitizePhoneInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const cleaned = (input.value || '').replace(/\D/g, '');
    if (cleaned !== input.value) {
      input.value = cleaned;
      this._formGroupItinerary?.get('phone')?.setValue(cleaned);
    }
  }

getDateInOut(date: string): string {
  if (!date) {
return 'Fecha no válida';
}

  // Primero parsear la fecha con el formato correcto
  const parsedDate = moment(date, 'DD-MMMM-YYYY', 'es');

  // Verificar si la fecha es válida
  if (!parsedDate.isValid()) {
    console.error('Fecha inválida:', date);
    return 'Fecha inválida';
  }

  // Formatear la salida
  return parsedDate.format('DD MMM YY');
}


}
